import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import BoxPort from './BoxPort';
import './EpikBoxPorts.css';
import { portConfig, updateSipPri } from '../../../../../actions/EpikBoxes';
import BoxSipPri from '../BoxSipPri/BoxSipPri';
import Spinner from '../../../../Spinner/Spinner';
import ExternalAtaPorts from './ExternalAtaPorts';
import { DEVICE_LOCK_BY_SOMEONE } from '../../../../../lib/constants';
import { toast } from 'react-toastify';
import utils from '../../../../../lib/utils';

export function obisToPort(obis, lastUpdate) {
  const lastUpdated = new Date(lastUpdate);
  const portDefault = {
    boxPortNumber: '',
    serviceName: '',
    connected: '',
    remoteHost: '',
    ipAddress: '',
    remotePort: '',
    authName: '',
    assignedNumber: '',
    monitored: true,
  };
  return obis.reduce((acc, obi, index) => {
    acc.push({
      ...portDefault,
      ...{ boxPortNumber: obi?.port1?.boxPortNumber },
      ...{ lastUpdated },
      ...{ status: obi?.status },
      ...{ obiIndex: index },
      ...{ portKey: 'port1' },
      ...obi.port1,
    });
    acc.push({
      ...portDefault,
      ...{ boxPortNumber: obi?.port2?.boxPortNumber },
      ...{ lastUpdated },
      ...{ status: obi?.status },
      ...{ obiIndex: index },
      ...{ portKey: 'port2' },
      ...obi.port2,
    });
    return acc;
  }, []);
}

function ataToPort(ata, lastUpdate) {
  const lastUpdated = new Date(lastUpdate);
  const portDefault = {
    boxPortNumber: '',
    serviceName: '',
    connected: '',
    remoteHost: '',
    ipAddress: '',
    remotePort: '',
    authName: '',
    assignedNumber: '',
    monitored: true,
  };
  return ata.reduce((acc, obi, index) => {
    if (ata[0].externalAtaPorts === '8') {
      // push 8 ports to acc and return acc
      for (let i = 1; i <= 8; i++) {
        acc.push({
          ...portDefault,
          ...{ boxPortNumber: obi[`port${i}`]?.boxPortNumber },
          ...{ lastUpdated },
          // ...{ status: obi?.status },
          ...{ obiIndex: index },
          ...{ portKey: `port${i}` },
          ...obi[`port${i}`],
        });
      }
    } else {
      // push 4 ports to acc and return acc
      for (let i = 1; i <= 24; i++) {
        acc.push({
          ...portDefault,
          ...{ boxPortNumber: obi[`port${i}`]?.boxPortNumber },
          ...{ lastUpdated },
          // ...{ status: obi?.status },
          ...{ obiIndex: index },
          ...{ portKey: `port${i}` },
          ...obi[`port${i}`],
        });
      }
    }
    return acc;
  }, []);
}

const EpikBoxPorts = ({
  box,
  obis,
  onSelect,
  onAtaSelect,
  selected,
  numbers,
  boxDetails,
  portConfig,
  onImportConfirm,
  importFinalList,
  onAssignAvailablePress,
  numberToFilter,
  onAvailableSave,
  finalSelectedList,
  state,
  setState,
  onBandManagementCall,
  oobList,
  OOBManagerHandler,

}) => {
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const token = localStorage.getItem('jwtToken') || null;
  const priSettings = useSelector(state => state.AppState.priSipData?.prisip?.priSettings);
  const sipSettings = useSelector(state => state.AppState.priSipData?.prisip?.sipSettings);
  const resetPortE911 = true;
  const dispatch = useDispatch();
  const ports = obisToPort(obis, box.lastUpdated);
  const lockStatusBox = useSelector(state => state.UIState.epikBoxes.lockStatusEpikBox);
  const [countdown, setCountdown] = useState(0);

  const timer = utils.calculateEpiFirmwareUpdateTimer(boxDetails?.epiFirmwareUpdateTimer);

  useEffect(() => {
    let portsArray = obisToPort(obis, box.lastUpdated);
    const registerdPort = portsArray.reduce((total, port) => total + port.registered ? 1 : 0, 0);

    const portCount = { registerdPort, totalPorts: portsArray.length };
    // setState({ ...state, portCount: { ...portCount } });

    if (box.OBEnable && box._id === window.location.pathname.split('/').pop()) {
      OOBManagerHandler(false);
    }
  }, [box]);

  useEffect(() => {
    let intervalId;

    const startCountdown = () => {
      intervalId = setInterval(() => {
        // Calculate remaining time in seconds

        const newData = new Date();
        const lastClickDate = new Date(boxDetails?.epiFirmwareUpdateTimer);
        const mintDifference = newData?.getTime() - lastClickDate?.getTime();
        const epiFwUpdateTimer = mintDifference / 60000;
        const timeRemaining = 15 - epiFwUpdateTimer;

        // Convert timeRemaining into minutes and seconds
        const minutes = Math.floor(timeRemaining);
        const seconds = Math.round((timeRemaining - minutes) * 60);
        const formattedTime = `${minutes}min ${seconds}sec`;

        // Update countdown
        setCountdown(formattedTime);
      }, 1000);
    };

    const stopCountdown = () => {
      clearInterval(intervalId);
    };

    // Start countdown when timer is available
    if (boxDetails?.epiFirmwareUpdateTimer && !timer) {
      startCountdown();
    }

    // Stop countdown and clear interval on component unmount
    return () => {
      stopCountdown();
    };
  }, [boxDetails?.epiFirmwareUpdateTimer, timer]);

  const externalPorts = ataToPort(box?.externalAta || [], box?.lastUpdate || new Date());

  if (ports.length === 0 && !box.OBEnable) {
    return (
      <>
        <div hidden={!!boxDetails.expansionBox} className="message">
          No Ports configured on Edge Device.
        </div>
        {boxDetails?.masterBox ? (
          <a
            hidden={!boxDetails.expansionBox}
            className="message"
            style={{ cursor: 'pointer' }}
            href={`/boxes/${boxDetails?.masterBox?._id}?company=${boxDetails.masterBox.assignedTo}`}
          >
            <h6
              style={{
                margin: '5px 0px 5px 0px',
                textAlign: 'center',
                color: '#212529',
              }}
            >
              EPIs have been moved to primary box {` ${boxDetails?.masterBox?.displayName || ''}`}
            </h6>
          </a>
        ) : null}
      </>
    );
  }
  const handleUpdateObi = async (reset, portData) => {
    const updatedPort = { ...portData, e911Number: reset ? '' : boxDetails.e911Number };
    const portKey = updatedPort.portKey;
    obis[updatedPort.obiIndex][portKey] = updatedPort;
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: boxDetails.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: obis[updatedPort.obiIndex],
    };
    portConfig(token, body);
  };

  const updateSipPriSetting = async (numberSettings, isPri) => {
    setIsLoaderOpen(true);
    const dataToAppend = isPri ? { ...priSettings } : { ...priSettings };
    const settings = {
      ...dataToAppend,
      numberSettings: numberSettings || [],
    };
    await dispatch(updateSipPri(token, box?._id, isPri, settings));
    setIsLoaderOpen(false);
  };

  return (
    <>
      {!timer && (
        <div className='overlay-text'>
          <span className='firmware-text'>EPI Firmware update in progress. Please wait {countdown}.</span>
        </div>
      )}
    <div className={`${timer ? 'portsContainer' : 'portsContainer firmware-update-running'}`}>
        {isLoaderOpen && <Spinner />}
        {ports.map(port => {
          return (
            <BoxPort
              key={Math.random()}
              box={box}
              resetE911={data => handleUpdateObi(resetPortE911, data)}
              assignE911ToPort={data => handleUpdateObi(false, data)}
              onPortSelect={onSelect}
              selected={(selected && selected.boxPortNumber) === port.boxPortNumber}
              port={port}
              numbers={numbers} />
          );
        })}

        {externalPorts?.map(port => {
          return (
            <ExternalAtaPorts
              key={Math.random()}
              box={box}
              onPortSelect={onAtaSelect}
              // onPortSelect={onSelect}
              selected={(selected && selected.boxPortNumber) === port.boxPortNumber}
              port={port} />
          );
        })}

        {box?.features?.sip && !box?.myEpik && (
          <BoxSipPri
            title="SIP"
            MainTitle="SIP Trunking"
            onAssignAvailablePress={onAssignAvailablePress}
            onImportConfirm={onImportConfirm}
            importFinalList={importFinalList}
            numberToFilter={numberToFilter}
            onAvailableSave={onAvailableSave}
            finalSelectedList={finalSelectedList}
            updatePriSipSetting={updateSipPriSetting}
            numberSettings={sipSettings?.numberSettings} />
        )}

        {box?.features?.pri && !box?.myEpik && (
          <BoxSipPri
            title="PRI"
            MainTitle="PRI Trunking"
            onAssignAvailablePress={onAssignAvailablePress}
            onImportConfirm={onImportConfirm}
            importFinalList={importFinalList}
            numberToFilter={numberToFilter}
            onAvailableSave={onAvailableSave}
            finalSelectedList={finalSelectedList}
            updatePriSipSetting={updateSipPriSetting}
            numberSettings={priSettings?.numberSettings} />
        )}

        {box?.OBEnable &&
          <div className="boxPortContainer"
            onClick={() => {
              lockStatusBox.locked ?
                toast.error(DEVICE_LOCK_BY_SOMEONE)
                :
                onBandManagementCall(true);
            } }
          >
            <div className="portLabel" id='oobm'>OOBM</div>
            <div className="portInfo">
              <span id="port-name-value">Port Discovered</span>
              <span id="port-name-value">{oobList?.assignedUsbs?.length} </span>
            </div>
            <div className="portInfo">
              <span id="port-name-value">Numbers Assigned</span>
              <span id="port-name-value">{oobList?.assignedUsbs?.length} </span>
            </div>
          </div>}
      </div></>
  );
};

const mapDispatchToProps = dispatch => ({
  portConfig: (token, body) => dispatch(portConfig(token, body)),
});
const mapStateToProps = state => ({
  addressModalData: state.AppState.provisioning.address,
  boxDetails: state.AppState.boxDetails.box,
  oobList: state.AppState.boxDetails.oobList,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikBoxPorts);
